import GraphqlBuilder from "utils/request/graphql/builder";
import MutationEmployeeScanIn from "graphql/mutations/MutationEmployeeScanIn";
import MutationEmployeeScanOut from "graphql/mutations/MutationEmployeeScanOut";
import _ from 'lodash'
import FetchEmployee from 'utils/fetch/FetchEmployee'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { SET_DATA } from 'services/redux/action-types'
import { MODE_SCAN_IN, MODE_SCAN_OUT } from 'utils/constants/qrcode-constants'

const Qrcode_Presence = {
	
	scanIn: ( qrcode, onSuccess, onError ) => {
		Qrcode_Presence.handleScan( MutationEmployeeScanIn, MODE_SCAN_IN, qrcode, onSuccess, onError );
	},
	
	scanOut: ( qrcode,  onSuccess, onError ) => {
		Qrcode_Presence.handleScan( MutationEmployeeScanOut, MODE_SCAN_OUT, qrcode, onSuccess, onError );
	},
	
	handleScan: ( query, scanMode, qrcode, onSuccess, onError ) => {
		let graphQlBuilder = new GraphqlBuilder();
		
		graphQlBuilder.addQuery( 'scan', query, {
			employee_guid: '::employee_guid',
			code: qrcode
		});
		
		graphQlBuilder.setOnSuccess( Qrcode_Presence.handledScan.bind( this, scanMode, onSuccess, onError ) );
		graphQlBuilder.setOnError( onError );
		graphQlBuilder.execute();
	},
	
	handledScan: ( scanMode, onSuccess, onError, result ) => {
		const employeeScan = _.get( result, ['scan', ( scanMode === MODE_SCAN_IN ? 'employee_scan_in_with_code' : 'employee_scan_out_with_code' )], {} );
		const employeeScanGuid = _.get( employeeScan, 'guid', null );
		
		// Is it null? Then it failed.. :(
		if( employeeScanGuid === null ) {
			onError();
			return;
		}
		
		Qrcode_Presence.reloadEmployee( employeeScan, onSuccess, onError );
	},
	
	reloadEmployee: ( employeeScan, onSuccess, onError ) => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		FetchEmployee.fetch( _employee.guid , {
			callbackSuccess: ( { employee } ) => {
				store.dispatch({
					type: SET_DATA,
					key: dataConstants.EMPLOYEE,
					payload: employee
				});
				
				onSuccess( employeeScan );
			},
			callbackError: onError
		});
	},
};

export default Qrcode_Presence
